// „Jak recenze ověřujeme": informace, jak shop ověřuje, že recenze píšou
// zákazníci (§ 5a odst. 5 ZOS), musí stát u zobrazených recenzí. Od 7. 10. 2026
// (zadání Tomáše) je to sekce stránky Hodnocení obchodu s kotvou z manifestu
// (`reviews.verifyAnchor`), kterou staví ratingsPage.js. Do té doby samostatná
// stránka /jak-recenze-overujeme/ (ostrá id 7123): v adminu je skrytá a její
// adresa přesměrovává 301 na tuhle kotvu.
//
// Odkazují sem karta recenzí na detailu (reviewHighlights.js), patička
// (reviews.js) a e-mail „Prosba o recenzi" (Ecomail, recenze U5). Kotva je
// adresa z odeslaných e-mailů, přejmenovat ji znamená rozbít jejich odkazy.
import SHOP from '../../config/shop.js';
import { page } from './pages.js';

/** id sekce na stránce hodnocení, nebo null (shop ji nemá, SK) */
export function verifyAnchor() {
  return SHOP.reviews.verifyAnchor || null;
}

/** `/hodnoceni-obchodu/#jak-recenze-overujeme`, nebo null (odkaz se nekreslí) */
export function verifyHref() {
  const id = verifyAnchor();
  const ratings = page('ratings');
  return id && ratings ? ratings + '#' + id : null;
}
